module.exports = require('./helpers/bundle-url').getBundleURL('8gVFb') + "logo.c51670a8.svg";